var cov_2j7o9dhdri = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/utils.ts",
      hash = "817ee19976d7a482c9430a1df8a96bb8043bf208",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/utils.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 29
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 94
        }
      },
      "2": {
        start: {
          line: 9,
          column: 52
        },
        end: {
          line: 9,
          column: 94
        }
      },
      "3": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 29
          },
          end: {
            line: 4,
            column: 30
          }
        },
        loc: {
          start: {
            line: 8,
            column: 5
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 94
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 94
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 94
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 22
          }
        }, {
          start: {
            line: 9,
            column: 26
          },
          end: {
            line: 9,
            column: 50
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { isFunc } from '../utils/is';
cov_2j7o9dhdri.s[0]++;
export var getCustomList = function getCustomList(list, renderOptionList, loading) {
  cov_2j7o9dhdri.f[0]++;
  cov_2j7o9dhdri.s[1]++;

  if ((cov_2j7o9dhdri.b[1][0]++, renderOptionList) && (cov_2j7o9dhdri.b[1][1]++, isFunc(renderOptionList))) {
    cov_2j7o9dhdri.b[0][0]++;
    cov_2j7o9dhdri.s[2]++;
    return renderOptionList(list, {
      loading: loading
    });
  } else {
    cov_2j7o9dhdri.b[0][1]++;
  }

  cov_2j7o9dhdri.s[3]++;
  return list;
};